/**
 * Sends canonical `address_line_2` alongside legacy `appartment` for POST /address/create and /address/update.
 * Backend maps either key into the `appartment` column.
 */
export function attachAddressLine2ForApi(body: Record<string, any>): Record<string, any> {
  const fromLine2 =
    body.address_line_2 != null && String(body.address_line_2).trim() !== ""
      ? String(body.address_line_2).trim()
      : "";
  const fromApt = body.appartment != null ? String(body.appartment).trim() : "";
  const line2 = fromLine2 || fromApt;
  const country = body.country != null ? String(body.country).trim() : "";
  return {
    ...body,
    appartment: fromApt || fromLine2,
    address_line_2: line2,
    ...(country ? { country } : {}),
  };
}
